import React, { useContext } from "react";
import { TeaserData } from "./teaser";
import TeaserTickerView from "./TeaserTickerView";
import { CatchlineTeaserEntry } from "../helper/interfaces";

export default function TeaserCatchline(data: TeaserData) {
  const baseTeaser = data.teaser as CatchlineTeaserEntry;

  return (
    <React.Fragment>
       <div className="teaser-list-module">
        {baseTeaser.teasers.map((teaser, indexTeaser) => (
          <React.Fragment
            key={`teasers-teaser-key-${teaser.id}-${baseTeaser.id}-${0}-${indexTeaser}`}
          >
            <TeaserTickerView
              teaser={teaser}
              ignoreLead={true}
              adInformation={data.adInformation}
              navigate={(id: string, ressortId: string) =>
                data.navigate?.(id, ressortId)
              }
            />
          </React.Fragment>
        ))}
      </div>
    </React.Fragment>
  );
}
